/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.directives {

    export interface IIfElseOperationScope extends IValueOperationScope {
        addConditionalOperand: () => void;
        deleteElseIfBlock: (index: number) => void;
    }

    export class IfElseOperation implements IDirective {
        public templateUrl: string = './app/views/directives/calculate/ifElseOperation.html';
        public restrict: string = 'E';
        public controller = ['$scope', 'calculationService', IfElseOperationController];
        public controllerAs = 'controller';
        public scope: boolean = true;  // False is use parents scope - True is create inherited scope from parents scope

        public link($scope: IIfElseOperationScope, element: JQuery, attrs: ng.IAttributes, controller: IfElseOperationController) { }
    }

    export class IfElseOperationController implements IController {

        constructor(private $scope: IIfElseOperationScope, private calculationService: services.CalculationService) {
            $scope.addConditionalOperand = () => this.addConditionalOperandInternal();
            $scope.deleteElseIfBlock = (index: number) => this.deleteElseIfBlockInternal(index);
        }

        private addConditionalOperandInternal(): void {
            this.calculationService.addNewSimpleOperandToValueOperation(this.$scope.getOperation());
            this.calculationService.addNewSimpleOperandToValueOperation(this.$scope.getOperation());
        }

        private deleteElseIfBlockInternal(index: number): void {
            var removedItems = this.$scope.getOperation().operands.splice(index, 2);
            removedItems.forEach((removedOperand) => {
                this.calculationService.deleteOperand(removedOperand);
            });
        }
    }
}

warsApp.registerDirective('IfElseOperation', []);